import React, { useEffect, useState } from "react"
import { Route } from "react-router-dom"
import { Spinner } from "reactstrap"
import { getCurrentUser } from "../auth.utils"
import "./publicPrivateRoute.css"
import ThemeAdmin from "../../components/ExtraComponents/ThemeAdmin"

export const PublicPrivateRoute = ({ component: Component, ...props }) => {
  const [authorize, setAuthorize] = useState(false),
    [loading, setLoading] = useState(true)

  useEffect(() => {
    getCurrentUser()
      .then((data) => {
        if (data) {
          setAuthorize(true)
        }
        setLoading(false)
      })
      .catch(() => {
        setAuthorize(false)
        setLoading(false)
      })
  }, [])

  return loading ? (
    <div className="d-flex align-items-center justify-content-center spinner_container">
      <Spinner size="lg" className="spinner" />
    </div>
  ) : (
    <Route
      {...props}
      render={props =>
        authorize ? (
          <ThemeAdmin>
            <Component {...props} authorize />
          </ThemeAdmin>
        ) : (
          <Component {...props} />
        )
      }
    />
  )
}
